import { AxiosInstance } from 'axios'
import { action, makeObservable, observable } from 'mobx'
import { getClient } from 'api'

type CaptchaStatus = 'idle' | 'inProgress' | 'success' | 'error'

class CaptchaStore {
  public captchaFlowStatus: CaptchaStatus = 'idle'
  private apolloClient: AxiosInstance

  constructor() {
    this.apolloClient = getClient('apollo')

    makeObservable(this, {
      captchaFlowStatus: observable,
      setCaptchaFlowStatus: action,
      postCaptchaToken: action,
      getCaptchaStatus: action
    })
  }

  setCaptchaFlowStatus = (status: CaptchaStatus) => {
    this.captchaFlowStatus = status
  }

  postCaptchaToken = async (token: string, traversalId: string | null) => {
    try {
      const response = await this.apolloClient.post(`/ctoken`, {
        token,
        traversalId
      })

      return response
    } catch (error) {
      throw error
    }
  }

  getCaptchaStatus = async (traversalId: string | null) => {
    try {
      const response = await this.apolloClient.get(
        `ctoken?traversalId=${traversalId}`
      )
      return response
    } catch (error) {
      throw error
    }
  }
}

export default CaptchaStore
